import React from 'react';

const ContactMap = () => {
    return (
        <section className="wpo-contact-map-section" >
            <div className="wpo-contact-map">
                <iframe title='comtact-map' src="https://maps.google.com/maps?q=%D0%A1%D0%BE%D0%B3%D0%B4%D0%B8%D0%B9%D1%81%D0%BA%D0%B0%D1%8F%20%D0%BE%D0%B1%D0%BB%D0%B0%D1%81%D1%82%D1%8C%2C%20%D0%91.%20%D0%93%D0%B0%D1%84%D1%83%D1%80%D0%BE%D0%B2%D1%81%D0%BA%D0%B8%D0%B9%20%D1%80%D0%B0%D0%B9%D0%BE%D0%BD%2C%20%D0%B4%D0%B6%D0%B0%D0%BC%D0%BE%D0%B0%D1%82%20%D0%A5%D0%B8%D1%81%D1%82%D0%B5%D0%B2%D0%B0%D1%80%D0%B7%2C%20%D1%83%D0%BB%D0%B8%D1%86%D0%B0%20%D0%94%D1%83%D1%81%D1%82%D0%B8%2C%20%D0%B4%D0%BE%D0%BC%20111&z=16&output=embed" width="600" height="450"  allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>

            </div>
        </section >
    );
};

export default ContactMap;